module.exports = __webpack_public_path__ + "static/media/endurance-icon.ff55378d.png";